import React, { useEffect, useState } from "react";
import dummyImg from "../../assets/images/dummy.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import PhoneNumberFormat from "../PhoneNumberFormate/PhoneNumberFormate";

export default function StudentsTable({ fetchApi, linkTo }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const auth = useSelector((state) => state.auth);
  const [allStudents, setAllStudents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStudents = async () => {
      if (!auth.token) {
        setError("Please log in to view students.");
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);
      try {
        const response = await fetchApi(auth.token);
        if (response?.success) {
          setAllStudents(response.data.details || []);
        } else {
          throw new Error(response?.message || "Failed to fetch data");
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
        toast.error(
          error?.message || "Failed to fetch data. Please try again.",
          {
            position: "top-center",
          }
        );
        setError(error?.message || "Failed to fetch data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchStudents();
  }, [auth.token, fetchApi]);

  const totalPages = Math.ceil((allStudents?.length || 0) / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentStudents = Array.isArray(allStudents)
    ? allStudents.slice(startIndex, endIndex)
    : [];

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      {isLoading && (
        <div className="loader-container">
          <div className="dottedLoading theme-color"></div>
        </div>
      )}
      <div className="d-flex align-item-center justify-content-end d-sm-none">
        <label className="me-2 flex-shrink-0 align-self-center">
          No of Rows
        </label>
        <select
          className="form-control ms-16"
          value={rowsPerPage}
          onChange={handleRowsChange}
          style={{ width: "100px" }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={30}>30</option>
          <option value={40}>40</option>
          <option value={50}>50</option>
        </select>
      </div>
      <div className="table-responsive mb-10">
        <table className="table student-table custom-table align-middle">
          <thead className="position-sticky top-0">
            <tr>
              <th className="ah-text-base" width="10%">
                Sr No.
              </th>
              <th className="ah-text-base" width="20%">
                Name
              </th>
              <th className="ah-text-base" width="20%">
                Email
              </th>
              <th className="ah-text-base" width="20%">
                Phone Number
              </th>
              <th className="ah-text-base" width="20%">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="5">Loading...</td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="5"><div className="alert alert-danger">Error: {error}</div></td>
              </tr>
            ) : currentStudents.length > 0 ? (
              currentStudents.map((student, index) => (
                <tr key={student.id}>
                  <td>
                    <div className="counter-block">
                      {startIndex + index + 1}
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <div className="img-holder me-15">
                        <img
                          src={
                            student?.profile_picture?.startsWith("/")
                              ? process.env.REACT_APP_GALLERY_URL +
                                "/" +
                                student?.profile_picture
                              : process.env.REACT_APP_GALLERY_URL +
                                student?.profile_picture
                          }
                          alt="Student"
                          className="img-fluid h-100 w-100"
                          onError={(e) => (e.target.src = dummyImg)}
                        />
                      </div>
                      <strong className="ah-text-sm fw-semibold">
                        {student.full_name}
                      </strong>
                    </div>
                  </td>
                  <td className="fw-medium">{student.email}</td>
                  <td className="fw-medium">
                    <PhoneNumberFormat
                      number={student.phone_number}
                      type="national"
                    />
                  </td>
                  <td className="fw-medium">
                    <Link
                      // `/admin-course-detail?id=${courseItem.id}

                      to={`${linkTo}?id=${student.id}`}
                      className="btn btn-primary fw-semibold no-shadow py-7 ah-text-sm"
                    >
                      View Details
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5"><div className="alert alert-info">No students found.</div></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center justify-content-sm-between align-items-center custom-pagination-holder">
        <div className="mx-auto">
          <button
            className="me-2 border-0 bg-transparent p-0 "
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <svg
              style={{ transform: "rotate(-90deg)" }}
              width="12"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Prev
          </button>
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i + 1}
              className={`bg-transparent border-0 ${
                currentPage === i + 1
                  ? "pagination-item active"
                  : "pagination-item"
              } me-2`}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button
            className="me-2 border-0 bg-transparent p-0"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
            <svg
              style={{ transform: "rotate(90deg)" }}
              width="12"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="align-item-center d-none d-sm-flex">
          <label className="me-2 flex-shrink-0 align-self-center">
            No of Rows
          </label>
          <select
            className="form-control ms-16"
            value={rowsPerPage}
            onChange={handleRowsChange}
            style={{ width: "100px" }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>
    </>
  );
}
